/**
* Verifica se há um número máximo de notificações para o limite anterior.
*
* @returns {boolean} - Retorna `true` se o número máximo de notificações for um número válido,
* caso contrário, `false`.
*/
const IsValidNumber = function(value)
{
	 return typeof value === "number" && !isNaN(value) && value !== null && value !== undefined;
};

export default { IsValidNumber };